import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import PerfectScrollbar from "react-perfect-scrollbar";


import profile from "../../../images/adminimg.jpg";
import avatar from "../../../images/avatar/1.jpg";
import { Dropdown } from "react-bootstrap";
import LogoutPage from './Logout';
import { useSelector } from "react-redux";
import { get_AdminSingleData } from "../../../store/actions/CommanAction";
import { FaSearch } from 'react-icons/fa';
import { Button, Form } from 'react-bootstrap';
import { getData } from "../../../ApiMethods/ApiMethods";


const Header = ({ onNote }) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [searchBut, setSearchBut] = useState(false);

	const [singleData, setSingleData] = useState();
	const [url, setUrl] = useState();
	const [profileImageUrl, setProfileImageUrl] = useState();
	const [ticketCount, setTicketCount] = useState("")
	const [getNottictionData, setGetNottictionData] = useState([])
	const [getNottictionInqury, setGetNottictionInqury] = useState([])
	const [showDropdown, setShowDropdown] = useState(false);
	const [showInquiryDropdown, setShowInquiryDropdown] = useState(false);

	const AdminID = useSelector((state) => state.feedBackReducer.AdminID);
	const AdminSingleData = useSelector((state) => state.feedBackReducer.AdminSingleData);


	useEffect(() => {

		if (AdminID) {
			dispatch(get_AdminSingleData(AdminID));
		}
	}, [AdminID]);

	useEffect(() => {
		if (Array.isArray(AdminSingleData) && AdminSingleData.length > 0) {
			setSingleData(AdminSingleData);
		} else {
		}
	}, [AdminSingleData]);

	useEffect(() => {
		if (singleData) {
			let formattedUrl = singleData[0]?.Photourl?.replace(/\\/g, '/');
			formattedUrl = `https://${formattedUrl}`;
			setUrl(formattedUrl);
		}
	}, [singleData]);


	useEffect(() => {
		if (!profileImageUrl && AdminSingleData?.length > 0) {
			let initialUrl = AdminSingleData[0]?.Photourl?.replace(/\\/g, '/');
			setProfileImageUrl(`https://${initialUrl}`);
		}
	}, [AdminSingleData, profileImageUrl]);






	var path = window.location.pathname.split("/");
	var name = path[path.length - 1].split("-");
	var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;

	var finalName = filterName.includes("app")
		? filterName.filter((f) => f !== "app")
		: filterName.includes("ui")
			? filterName.filter((f) => f !== "ui")
			: filterName.includes("uc")
				? filterName.filter((f) => f !== "uc")
				: filterName.includes("basic")
					? filterName.filter((f) => f !== "basic")
					: filterName.includes("jquery")
						? filterName.filter((f) => f !== "jquery")
						: filterName.includes("table")
							? filterName.filter((f) => f !== "table")
							: filterName.includes("page")
								? filterName.filter((f) => f !== "page")
								: filterName.includes("email")
									? filterName.filter((f) => f !== "email")
									: filterName.includes("ecom")
										? filterName.filter((f) => f !== "ecom")
										: filterName.includes("chart")
											? filterName.filter((f) => f !== "chart")
											: filterName.includes("editor")
												? filterName.filter((f) => f !== "editor")
												: filterName;



	const getListNames = (RouteName) => {
		// return 
		switch (RouteName) {
			case 'AdminUserList': {
				return 'Admin User List'
			}
			case 'astrolist': {
				return 'Astrologers List'
			}
			case 'Astrolist': {
				return 'Astrologers List'
			}
			case 'userlist': {
				return 'User List'
			}
			case 'Userlist': {
				return 'User List'
			} 
			case 'adminuser': {
				return 'Admin User'
			}
			case 'PujaListFilter': {
				return 'Booking Pooja List'
			}
			case 'GemstoneListFilter': {
				return 'Gemstone Order List'
			}
			case 'PoojaFor': {
				return 'Pooja For'
			}
			case 'ChatHistory': {
				return 'Chat History'
			}
			case 'CallHistory': {
				return 'Call History'
			}
			case 'CategoryNotification': {
				return 'Category Notification'
			}
			case 'DataPushNotification': {
				return 'DataPush Notification'
			}
			case 'policy': {
				return ' Privacy Policy'
			}
			case 'Blog': {
				return 'Blog'
			}
			case 'BlogHome': {
				return 'Blog Home'
			}
			case 'Horoscope': {
				return 'Horoscope'
			}
			case 'Muhurat': {
				return 'Muhurat'
			}
			case 'VratUpvaas': {
				return 'Vrat Upvaas'
			}


			case 'SkillsList': {
				return 'Skills'
			}
			case 'LanguagesList': {
				return 'Languages List'
			}
			case 'BlogCategoryList': {
				return 'Blog Category List'
			}
			case 'MuhuratCategory': {
				return 'Muhurat Category'
			}
			case 'DregeeDiploma': {
				return ' Dregee Diploma'
			}
			case 'AstrologersCategory': {
				return 'Astrologers Category'
			}
			case 'Gemstone': {
				return 'Gemstone Category'
			}
			case 'GemstoneUserList': {
				return 'Gemstone Order List'
			}
			case 'GemstoneCartList': {
				return 'Gemstone Cart List'
			}

			case 'VratUpvaasCategory': {
				return 'Vrat Upvaas Category'
			}
			case 'ExpenseCategory': {
				return 'Expense Category'
			}
			case 'TransactionCategory': {
				return 'Transaction Category'
			}
			case 'IncomeCategory': {
				return 'Income Category'
			}

			case 'HomeSlider': {
				return 'Home Slider'
			}
			case 'Feedback': {
				return 'Customer Feedback'
			}

			case 'Video': {
				return 'Video'
			}
			case 'PoojaList': {
				return 'Pooja List'
			}
			case 'GemstoneList': {
				return 'Gemstone List'
			}
			case 'Contact': {
				return 'Contact '
			}
			case 'Wallet': {
				return 'Recharge Package '
			}
			case 'paymenthistory': {
				return ' All Payment History '
			}
			case 'userwalletTransaction': {
				return 'Users Payment History '
			}
			case 'AstrowalletTransaction': {
				return 'Astrologers Payment History '
			}
			case 'Transaction': {
				return 'Transaction '
			}
			case 'Addcompany': {
				return 'Add Company '
			}
			case 'ExpenseDetails': {
				return 'Expense Details '
			}
			case 'TicketCategory': {
				return 'Ticket Category '
			}
			case 'paymentpagevisitors': {
				return 'Payment Page Visit Customer '
			}
			case 'astrologerpricechange': {
				return 'Astrologer Price Change  '
			}
			case 'astrogallery': {
				return 'Astrologer Gallery  '
			}
			case 'userreview': {
				return 'User Reviews '
			}
			case 'notloginuser': {
				return 'Not Login Users '
			}
			case 'allmenupages': {
				return 'All Menu Pages '
			}
			case 'festival': {
				return 'Festival '
			}
			case 'NotificationRule': {
				return 'Notification Rule'
			}
			case 'astrohome': {
				return 'Astrologer Home'
			}
			case 'PoojaListAdd': {
				return 'Pooja List Add'
			}
			case 'notificationrulelist': {
				return 'Notification Rule List'
			}


			default: return 'DashBoard'
		}

	}

	const TicketCount = async () => {
		try {
			const res = await getData("Ticket/TicketCount")

			setTicketCount(res)

		} catch (error) {
			console.log(error, "error")
		}
	}

	const GetNottictionData = async () => {
		try {
			const res = await getData("Ticket/GetNottictionData")

			setGetNottictionData(res)

		} catch (error) {
			console.log(error, "error")
		}
	}

	const GetNottictionInqury = async () => {
		try {
			const res = await getData("Ticket/GetNottictionInqury")

			setGetNottictionInqury(res)

		} catch (error) {
			console.log(error, "error")
		}
	}

	useEffect(() => {
	TicketCount();

	const interval = setInterval(() => {
		TicketCount(); 
	}, 300000);

	return () => clearInterval(interval);
}, []);
	const handleRedirect = (item) => {
		setShowDropdown(false);
		if (item.Product === "Ticket") {
			navigate(`/Tickets`);
		}
		else if (item.Product === "Puja") {
			navigate(`/PujaListFilter`);
		}
		else {
			navigate(`/GemstoneListFilter`);
		}
	}
	const handleInquiryRedirect = (item) => {
		setShowInquiryDropdown(false); // 

		navigate(`/Contact`);
	};

	return (
		<div className="header border-bottom">
			<div className="header-content">
				<nav className="navbar navbar-expand">
					<div className="collapse navbar-collapse justify-content-between">
						<div className="header-left" style={{ marginLeft: "150px" }}>



							<div className="search-bar-wrapper ml-5">
								<div className="search-bar-container">

									<span className="search-icon">
										<FaSearch size={16} />
									</span>



									<input
										type="text"
										placeholder="Search or type command..."
										className="search-input"
									/>


									<button className="search-keyboard-btn" type="button">
										<span>⌘</span>
										<span>K</span>
									</button>
								</div>
							</div>

						</div>

						<ul className="navbar-nav header-right">
							<Dropdown
								as="li"
								className="nav-item dropdown notification_dropdown"
								show={showInquiryDropdown}
								onToggle={(isOpen) => {
									setShowInquiryDropdown(isOpen);

									if (isOpen && getNottictionInqury.length === 0) {
										GetNottictionInqury();
									}
								}}
							>
								<Dropdown.Toggle
									variant=""
									as="a"
									className="nav-link bell bell-link i-false c-pointer"
								>
									<svg xmlns="http://www.w3.org/2000/svg" width="26.667" height="24" viewBox="0 0 26.667 24">
										<g id="_014-mail" data-name="014-mail" transform="translate(0 -21.833)">
											<path id="Path_1962" data-name="Path 1962" d="M26.373,26.526A6.667,6.667,0,0,0,20,21.833H6.667A6.667,6.667,0,0,0,.293,26.526,6.931,6.931,0,0,0,0,28.5V39.166a6.669,6.669,0,0,0,6.667,6.667H20a6.669,6.669,0,0,0,6.667-6.667V28.5A6.928,6.928,0,0,0,26.373,26.526ZM6.667,24.5H20a4.011,4.011,0,0,1,3.947,3.36L13.333,33.646,2.72,27.86A4.011,4.011,0,0,1,6.667,24.5ZM24,39.166a4.012,4.012,0,0,1-4,4H6.667a4.012,4.012,0,0,1-4-4V30.873L12.693,36.34a1.357,1.357,0,0,0,1.28,0L24,30.873Z" transform="translate(0 0)" fill="#135846" />
										</g>
									</svg>

									<span className="badge light text-white bg-primary rounded-circle">
										{/* {ticketCount[0]?.Inquirycount} */}
										  {ticketCount?.[0]?.Inquirycount}
									</span>
								</Dropdown.Toggle>


								<Dropdown.Menu
									className="dropdown-menu-end p-0"
									style={{ width: "10px" }}
								>
									<div style={{ maxHeight: "300px", overflowY: "auto" }}>

										{getNottictionInqury?.length > 0 ? (
											getNottictionInqury.map((item, index) => (
												<div
													key={index}
													className="px-3 py-2 border-bottom"
													style={{ cursor: "pointer" }}
													onClick={() => handleInquiryRedirect(item)}
												>

													<span className="text-primary fw-bold">
														{item?.InquiryRelated}
													</span>
												</div>
											))
										) : (
											<div className="text-center p-3">
												No Inquiry Found
											</div>
										)}

									</div>
								</Dropdown.Menu>
							</Dropdown>
							<Dropdown
								as="li"
								className="nav-item dropdown notification_dropdown"
								show={showDropdown}
								onToggle={(isOpen) => {
									setShowDropdown(isOpen);

									if (isOpen && getNottictionData.length === 0) {
										GetNottictionData();
									}
								}}
							>
								<Dropdown.Toggle
									className="nav-link i-false c-pointer"
									variant=""
									as="a"
								>
									🔔
									<span className="badge light text-white bg-primary rounded-circle">
										{ticketCount?.[0]?.Ticketcount}
										 
									</span>
								</Dropdown.Toggle>


								<Dropdown.Menu
									className="dropdown-menu-end p-0"
									style={{ width: "320px" }}
								>
									<div style={{ maxHeight: "300px", overflowY: "auto" }}>

										{getNottictionData?.length > 0 ? (
											getNottictionData.map((item, index) => (
												<div
													key={index}
													className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom"
													style={{ cursor: "pointer" }}
													onClick={() => handleRedirect(item)}
												>

													<span className="fw-semibold text-dark">
														{item?.Name}
													</span>


													<span className="text-primary fw-bold">
														{item?.Product}
													</span>
												</div>
											))
										) : (
											<div className="text-center p-3">
												No Notifications
											</div>
										)}

									</div>
								</Dropdown.Menu>
							</Dropdown>
							{/* <Dropdown
								as="li"
								className="nav-item  notification_dropdown "
							>
								<Dropdown.Toggle
									variant=""
									as="a"
									className="nav-link  ai-icon i-false c-pointer"
									// href="#"
									role="button"
									data-toggle="dropdown"
								>
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="21.6" viewBox="0 0 24 21.6">
										<g id="_008-chat" data-name="008-chat" transform="translate(-250.397 -62.547)">
											<path id="Path_1956" data-name="Path 1956" d="M274.4,67.347a4.8,4.8,0,0,0-4.8-4.8H255.2a4.8,4.8,0,0,0-4.8,4.8v15.6a1.2,1.2,0,0,0,2.048.848l3.746-3.745a2.4,2.4,0,0,1,1.7-.7H269.6a4.8,4.8,0,0,0,4.8-4.8Zm-2.4,0a2.4,2.4,0,0,0-2.4-2.4H255.2a2.4,2.4,0,0,0-2.4,2.4v12.7l1.7-1.7a4.8,4.8,0,0,1,3.395-1.406H269.6a2.4,2.4,0,0,0,2.4-2.4Zm-15.6,7.2H266a1.2,1.2,0,1,0,0-2.4h-9.6a1.2,1.2,0,0,0,0,2.4Zm0-4.8h12a1.2,1.2,0,1,0,0-2.4h-12a1.2,1.2,0,0,0,0,2.4Z" fill="#135846" fill-rule="evenodd" />
										</g>
									</svg>
								
								</Dropdown.Toggle>
								
							</Dropdown> */}

							<Dropdown as="li" className="nav-item dropdown header-profile">
								<Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer">
									<img src={profileImageUrl || profile} width={20} alt="" />
								</Dropdown.Toggle>
								<Dropdown.Menu align="right" className="mt-3 dropdown-menu dropdown-menu-end">

									<Link
										to="/adminuser"
										className="dropdown-item ai-icon"
										onClick={() => {
											dispatch(get_AdminSingleData(sessionStorage.getItem("ID",
											)))
										}}
									>
										<img className="me-3 rounded" src={profileImageUrl || profile} alt="User Avatar" />
										<span className="ms-2">Profile </span>
									</Link>


									<LogoutPage />
								</Dropdown.Menu>
							</Dropdown>
						</ul>
					</div>
				</nav>
			</div>

		</div>
	);
};

export default Header;
